import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { WorkOrder } from '../state-man/models/work-order.model';
import { LoggerService } from './logger.service';
import { UiService } from './ui.service';

@Injectable({
  providedIn: 'root'
})
export class WorkOrderService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  // version: the one that came with the work orders already held, or '' for none.
  public async getScheduled (version: string) : Promise<{ version: string, rows: WorkOrder[] | null } | null> {
    try {
      const ret = await this.apiService.getVersionedList('work_order/scheduled/', version)
      return ret && { version: ret.version, rows: ret.rows && WorkOrder.buildMany(ret.rows) }
    } 
    catch (error) {          
      LoggerService.log(error + ': work_order/scheduled/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }
  }

  public async getOpen () : Promise<WorkOrder[] | null> {
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'work_order/mine/')           
      return (ret && Array.isArray(ret)) ? WorkOrder.buildMany(ret) : null
    } 
    catch (error) {          
      LoggerService.log(error + ': work_order/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }
  }  
  
}
